function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0,9.23889299 C0,9.91589299 0.756,10.254893 1.2,9.77589299 L6.794,5.53689299 C7.068,5.24089299 7.068,4.75989299 6.794,4.46289299 L1.2,0.223892989 C0.756,-0.254107011 0,0.0838929892 0,0.759892989 L0,9.23889299 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-5 -5 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/forward.11bffd58.svg";
export { SvgComponent as ReactComponent };